import { startOfYear } from "date-fns";

type SingleDateParamInput = {
  earliest: Date;
  from: Date;
  hasEnd: boolean;
  hasStart: boolean;
  to: Date;
};

export type SingleDateParamResolution =
  | { kind: "unchanged" }
  | { kind: "reset" }
  | { from: Date; kind: "range"; to: Date };

/**
 * A URL with only one of start_datetime / end_datetime would otherwise pair
 * the given date with today's default. Outside the lookback window the date
 * is dropped for the default range. Inside it, a lone start date keeps
 * today as the end, and a lone end date starts at the beginning of its
 * year, kept within the window.
 */
export function resolveSingleDateParam({
  earliest,
  from,
  hasEnd,
  hasStart,
  to,
}: SingleDateParamInput): SingleDateParamResolution {
  if (hasStart === hasEnd) {
    return { kind: "unchanged" };
  }

  if (hasStart) {
    return from < earliest ? { kind: "reset" } : { kind: "unchanged" };
  }

  if (to < earliest) {
    return { kind: "reset" };
  }

  const startOfGivenYear = startOfYear(to);
  return {
    from: startOfGivenYear < earliest ? earliest : startOfGivenYear,
    kind: "range",
    to,
  };
}
